gsap.registerPlugin('ScrollTrigger');

gsap.defaults({ease: "none", duration: 8});

// create a sequence that moves 3 of the panels in from different directions
const tl = gsap.timeline({id: "timeline"});
tl
  .from(".panel-two", {
    opacity:0,
    delay: 2,
  })


  .from(".panel-three", {
    opacity:0,
    delay: 2,
  })
  .from(".panel-three .animateUp", {
    y:124,
    delay: 1,
  })
  .from(".panel-three .animateDown", {
    opacity:0
  })


  .from(".panel-four", {
    opacity:0,
    delay: 20,
  })
  .from(".panel-four .alshape", {
    scale: 0,
    // opacity:0,
    delay: 5,
  })



  .from(".panel-five", {
    opacity:0,
    delay: 20,
  })
  .from(".panel-five .animateUp", {
    y:85,
    delay: 0,
  })
  .from(".panel-five .animateDown", {
    opacity:0,
    y:-85,
    delay: 0,
  })
  .to(".panel-five .animateUp", {
    scale: 8,
    delay: 20,
  })


  .from(".panel-six", {
    opacity:0,
    delay: 10,
  })
  .from(".panel-six .aha-text", {
    scale: 20,
    xPercent: 48,
    opacity:0,
    delay: 1,
    duration: 40,
  })
  .from(".panel-six .aha-logo", {
    y: -10,
    opacity:0,
    delay: 1,
    duration: 10,
  })
  .from(".panel-six .textin-first", {
    y: -20,
    opacity:0,
    delay: 5,
    duration: 20,
  })
  .from(".panel-six .textin-second", {
    x: -20,
    opacity:0,
    delay: 5,
    duration: 20,
  })
  .from(".panel-six .textin-third", {
    x: 20,
    opacity:0,
    delay: 5,
    duration: 20,
  })


  .from(".panel-seven", {
    opacity:0,
    delay: 15,
  })
  .from(".panel-seven .firstDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-seven .secondDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-seven .brain", {
    opacity:0,
    y: -20,
    scale: 0.5,
    ease: "back",
    duration: 50,
    delay: 5,
  })


  .from(".panel-eight", {
    opacity:0,
    delay: 5,
  })
  .from(".panel-eight .secondDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .to(".panel-eight .brainimg", {
    opacity:0.5,
    duration: 2,
    delay: 1,
  })
  .from(".panel-eight .textoverlay", {
    opacity:0,
    y: -20,
    scale: 0.5,
    duration: 4,
    delay: 1,
  })


  .from(".panel-nine", {
    opacity:0,
    delay: 5,
  })

  .from(".panel-ten", {
    opacity: 0,
    delay: 50,
  })

  .from(".panel-ten .firstDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-ten .bar-1", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-2", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-3", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-4", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-5", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-6", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })
  .from(".panel-ten .bar-7", {
    opacity: 0.1,
    y: 20,
    delay: 2,
  })


  .from(".panel-eleven", {
    opacity:0,
    delay: 15,
  })
  .from(".panel-eleven .secondDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-eleven .thirdDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })

  .from(".panel-twelve", {
    opacity:0,
    delay: 15,
  })
  .from(".panel-twelve .secondDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-twelve .thirdDown", {
    y: -20,
    opacity:0,
    delay: 5,
  })

  .from(".panel-thirteen", {
    opacity:0,
    delay: 10,
  })
  .from(".panel-thirteen .firstDown", {
    y: 20,
    opacity:0,
    delay: 5,
  })
  .from(".panel-thirteen .secondDown", {
    opacity:0,
    delay: 5,
  })

ScrollTrigger.create({
  animation: tl,
  trigger: ".scrollcontainer",
  start: "top top",
  end: "+=10000",
  scrub: true,
  pin: true,
  anticipatePin: 1,
});

